export default __webpack_public_path__ + "static/media/downArrow.0d49a25a.svg";